import "core-js/modules/es.array.reverse.js";
var _class, _UrlTemplateImageryCatalogItem;
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import UrlTemplateImageryProvider from "terriajs-cesium/Source/Scene/UrlTemplateImageryProvider";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import UrlTemplateImageryCatalogItemTraits from "../../../Traits/TraitsClasses/UrlTemplateImageryCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";

/** See https://cesium.com/learn/cesiumjs/ref-doc/UrlTemplateImageryProvider.html#url for available keywords:
 * - {z}: The level of the tile in the tiling scheme. Level zero is the root of the quadtree pyramid.
 * - {x}: The tile X coordinate in the tiling scheme, where 0 is the Westernmost tile.
 * - {y}: The tile Y coordinate in the tiling scheme, where 0 is the Northernmost tile.
 * - {s}: One of the available subdomains, used to overcome browser limits on the number of simultaneous requests per host.
 */
let UrlTemplateImageryCatalogItem = (_class = (_UrlTemplateImageryCatalogItem = class UrlTemplateImageryCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(UrlTemplateImageryCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return UrlTemplateImageryCatalogItem.type;
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get mapItems() {
    const imageryProvider = this.imageryProvider;
    if (!isDefined(imageryProvider)) {
      return [];
    }
    return [{
      show: this.show,
      alpha: this.opacity,
      imageryProvider,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
  get imageryProvider() {
    if (!isDefined(this.url)) {
      return;
    }
    return new UrlTemplateImageryProvider({
      url: proxyCatalogItemUrl(this, this.url),
      subdomains: this.subdomains.slice(),
      credit: this.attribution,
      maximumLevel: this.maximumLevel,
      minimumLevel: this.minimumLevel,
      tileHeight: this.tileHeight,
      tileWidth: this.tileWidth,
      pickFeaturesUrl: this.pickFeaturesUrl,
      enablePickFeatures: this.allowFeaturePicking
    });
  }
}, _defineProperty(_UrlTemplateImageryCatalogItem, "type", "url-template-imagery"), _UrlTemplateImageryCatalogItem), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _class);
export { UrlTemplateImageryCatalogItem as default };